import type { OfferLeadDiversionReason, OfferPlanAvailability } from '../types';
import { logOfferUnavailable } from './logOfferUnavailable';
import {
  OFFER_CLOSED_REASON,
  OFFER_NOT_STARTED_REASON,
  OFFER_SOLD_OUT_REASON,
  buildOfferUnavailableRoute,
  type OfferUnavailableReason,
} from './offerUnavailableRoute';
import {
  resolveOfferLeadDiversionFresh,
  type FetchOfferAvailability,
} from './resolveOfferLeadDiversionFresh';

type Query = Record<string, string | string[] | undefined>;

const ROUTE_REASON_BY_LOG_REASON: Record<
  OfferLeadDiversionReason,
  OfferUnavailableReason
> = {
  expired: OFFER_CLOSED_REASON,
  not_started: OFFER_NOT_STARTED_REASON,
  sold_out: OFFER_SOLD_OUT_REASON,
};

/**
 * FIN-8016: depois do lead cadastrado, manda a oferta encerrada ou ainda
 * não aberta para a página de obrigado. Devolve true quando desviou; o
 * chamador para.
 * FIN-8011: com `fetchAvailability`, o valor guardado que desviaria é
 * conferido no BFF antes (a oferta pode ter aberto com a página aberta).
 */
export async function divertUnavailableOfferLead({
  routerQuery,
  leadRoute,
  context,
  push,
  fetchAvailability,
}: {
  routerQuery: Query;
  leadRoute?: string | null;
  context:
    | {
        offerAvailability?: OfferPlanAvailability | null;
        productCode?: string | null;
        productBusiness?: string | null;
        setLoading?: (isLoading: boolean) => void;
        setOfferAvailability?: (
          offerAvailability: OfferPlanAvailability | null
        ) => void;
      }
    | null
    | undefined;
  push: (route: ReturnType<typeof buildOfferUnavailableRoute>) => unknown;
  fetchAvailability?: FetchOfferAvailability;
}): Promise<boolean> {
  const planId =
    typeof routerQuery.oferta === 'string' ? routerQuery.oferta : null;

  const { diversion, offerAvailability, refreshed } =
    await resolveOfferLeadDiversionFresh({
      isOfferFlow: !!routerQuery.oferta,
      offerAvailability: context?.offerAvailability,
      leadRoute,
      planId,
      business: context?.productBusiness,
      fetchAvailability,
    });

  if (refreshed) {
    context?.setOfferAvailability?.(offerAvailability ?? null);
  }

  if (!diversion.divert) return false;

  logOfferUnavailable({
    operation: 'lead-diversion',
    planId: routerQuery.oferta as string,
    productCode: context?.productCode,
    reason: diversion.reason,
    business: context?.productBusiness,
  });
  push(
    buildOfferUnavailableRoute(
      routerQuery,
      ROUTE_REASON_BY_LOG_REASON[diversion.reason]
    )
  );
  context?.setLoading?.(false);

  return true;
}
